import { Icon } from '../ui/Icon'
import { LAUNCHPAD_TILES } from '../ui/launchpad'

/**
 * The ＋ launchpad card at the foot of the rail — avg-design's card, built as TEXT.
 *
 * It shipped first as their two SVG cuts and the owner read it back immediately:
 * 畫面看起來好糊. The art is drawn 1120px wide and the rail shows it at ~300, a 3.7×
 * downscale that lands the type at 4–6px — below a pixel stroke, so it anti-aliases
 * into grey mush. No image format fixes that; the artwork is sized for a full-width
 * hero, not a rail. Real text renders crisp at any width and DPI, reflows instead of
 * shrinking, and honours the reader's font size.
 *
 * Every colour in the design is already a theme variable with a `:root.light`
 * override, so ONE component covers both themes — where two exported files also meant
 * two things to keep in sync, and the pair had already drifted.
 *
 * The three tiles come from `LAUNCHPAD_TILES`, shared with the ＋ sheet's tab strip:
 * what this card PROMISES and what that sheet DOES are one list. They stack rather
 * than sitting in a row — three columns in a 300px rail is what forced the original
 * art's type down to 4px in the first place.
 */
export function PlusLaunchpad() {
  return (
    <>
      {/* The elastic gap. It GROWS to hold the card against the bottom of an empty
          rail and SHRINKS to a fixed minimum once the list fills the column — which
          `margin-top: auto` on the card could not do, because an auto margin has no
          minimum and collapsed the card flush against the last row. */}
      <div className="lp-spacer" role="none" aria-hidden="true" />

      {/* role="none": #sbList is a role="tree", whose children must be treeitems. This
          is guidance living inside the scroller, so it opts out of tree semantics
          rather than pretending to be a row. */}
      <div className="sb-launchpad" role="none">
        <p className="lp-head">Build your crew.</p>

        <ul className="lp-tiles">
          {LAUNCHPAD_TILES.map((t) => (
            <li key={t.title} className="lp-tile">
              <span className={`lp-chip lp-${t.color}`}>
                <Icon name={t.icon} size={13} />
              </span>
              <span className="lp-tile-txt">
                <span className="lp-tile-title">{t.title}</span>
                <span className="lp-tile-sub">{t.sub}</span>
              </span>
            </li>
          ))}
        </ul>

        {/* "START HERE" reads INTO the lead, both anchored bottom-right (owner:
            把 Start here 這串字移動到指示卡片箭頭的左邊). The label lost its own green
            bullet: the lead already starts with a dot, and the two sat close enough to
            read as one thing stuttering. The row stops 58px short of the card's right
            edge, which is what keeps the head clear of the ＋ FAB. */}
        <div className="lp-foot">
          <p className="lp-over">START HERE</p>
          <svg className="lp-lead" viewBox="0 0 120 24" aria-hidden="true">
            <circle className="lp-lead-dot" cx="5" cy="12" r="4" />
            <path
              d="M15 12H99"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeDasharray="1 6"
            />
            <path
              d="m100 5 11 7-11 7"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  )
}
